import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'
import { ClusterPlanTypeDto } from '@camunda-cloud/cloud-node-libs'
import { Observable } from 'rxjs'
import { ClusterPlanApiService } from '../services/clusterPlan.api.service'

@Injectable({
  providedIn: 'root',
})
export class ClusterPlanTypesResolverService
  implements Resolve<ClusterPlanTypeDto[]> {
  constructor(private apiService: ClusterPlanApiService) {}
  public resolve(): Observable<ClusterPlanTypeDto[]> {
    return this.apiService.getTypes()
  }
}
